module.exports = __webpack_public_path__ + "static/portfolio-mas-12-630843913c7624615afa4e0c404c6dae.jpg";